import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  MachineUsageV2,
  StateService,
  ToolService,
} from 'projects/shared/src/public-api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-machine-usage-overview',
  templateUrl: './machine-usage-overview.component.html',
  styleUrls: ['./machine-usage-overview.component.scss'],
  standalone: false,
})
export class MachineUsageOverviewComponent implements OnInit, OnDestroy {
  constructor(public state: StateService, public toolService: ToolService) {}

  allEntries: MachineUsageV2[] = [];
  filteredEntries: MachineUsageV2[] = [];
  selectedConSite: string = null;
  selectedMachine: string = null;
  selectedMonth: number = new Date().getMonth();
  selectedYear: number = new Date().getFullYear();
  sub: Subscription;

  ngOnInit() {
    this.sub = this.state.machineUsages$.subscribe((x) => {
      this.allEntries = x ?? [];
      this.filterEntries();
    });
    this.state.ensureMachineUsagesLoaded();
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  conSiteChanged(id: string) {
    this.selectedConSite = id;
    this.filterEntries();
  }

  machineChanged(id: string) {
    this.selectedMachine = id;
    this.filterEntries();
  }

  monthChanged(month: number) {
    this.selectedMonth = month;
    this.filterEntries();
  }

  yearChanged(year: number) {
    this.selectedYear = year;
    this.filterEntries();
  }

  filterEntries() {
    this.filteredEntries = this.allEntries.filter((x) => {
      if (
        this.selectedConSite != null &&
        x.constructionSite != this.selectedConSite
      )
        return false;
      if (this.selectedMachine != null && x.id != this.selectedMachine)
        return false;
      if (this.selectedMonth == null && this.selectedYear == null) return true;
      if (x.date == null) return false;
      const date = new Date(x.date);
      if (
        this.selectedMonth != null &&
        date.getUTCMonth() != this.selectedMonth
      )
        return false;
      if (
        this.selectedYear != null &&
        date.getUTCFullYear() != this.selectedYear
      )
        return false;
      return true;
    });
  }

  getTotalHours(): number {
    return this.filteredEntries.reduce(
      (sum, x) => sum + (x.usageInHours ?? 0),
      0
    );
  }
}
